/**
 * Knowledge-base constants mirrored from backend/kb/matrice.py.
 * Extended for 12 product families (F01–F12) and 30+ parameters.
 *
 * If backend matrice changes, run /api/admin/matrice once and replace.
 */
export const PARAM_LABELS = {
  P01_DN: "DN",
  P02_connessione: "Connessione",
  P03_filettatura: "Filettatura",
  P04_flangia_norma: "Norma flangia",
  P06_PN: "PN",
  P08_TS: "Temp.",
  P10_materiale: "Materiale",
  P11_tenuta: "Tenuta",
  P13_tipo_otturatore: "Otturatore",
  P16_azionamento: "Comando",
  P18_fluido: "Fluido",
  P21_settore: "Settore",
  P22_certificazioni: "Certificazioni",
  P30_spessore: "Spessore (mm)",
  P31_schedule: "Schedule",
  P32_lunghezza_mm: "Lunghezza (mm)",
  P33_forma_fondello: "Forma",
  P34_tipo_flangia: "Tipo flangia",
  P35_finitura_facing: "Facing",
  P36_tipo_valvola_reg: "Tipo valvola reg.",
  P37_kv_rated: "Kv (m³/h)",
  P38_range_taratura: "Range taratura",
  P39_dim_lxl: "Dim. L×l (mm)",
  P40_finitura_superficie: "Finitura",
  P41_tipo_strumento: "Tipo strumento",
  P42_attacco_strumento: "Attacco",
  P43_portata_m3h: "Portata (m³/h)",
  P44_prevalenza_m: "Prevalenza (m)",
  P45_potenza_kw: "Potenza (kW)",
  P46_alimentazione: "Alimentazione",
  P47_tipo_scambiatore: "Tipo scambiatore",
  P48_tipo_accessorio: "Tipo accessorio",
};

export const PARAM_SHORT = { ...PARAM_LABELS };

export const PARAM_VALUES = {
  P01_DN: [
    "DN10", "DN15", "DN20", "DN25", "DN32", "DN40", "DN50",
    "DN65", "DN80", "DN100", "DN125", "DN150", "DN200", "DN250",
    "DN300", "DN400", "DN500",
  ],
  P02_connessione: [
    "Filettato", "Flangiato", "A saldare",
    "A compressione", "A pressare", "Scanalato",
  ],
  P03_filettatura: ["BSP cilindrica", "BSP conica", "NPT", "Gas UNI ISO 7"],
  P04_flangia_norma: ["EN 1092-1", "UNI 2276/2278", "ASME B16.5"],
  P06_PN: ["PN6", "PN10", "PN16", "PN25", "PN40", "PN63", "PN100"],
  P08_TS: null,
  P10_materiale: [
    "AISI 304", "AISI 304L", "AISI 316", "AISI 316L",
    "Acciaio P235GH", "Acciaio P265GH", "Ottone OT58",
    "Bronzo", "Ghisa GG-25", "Ghisa sferoidale GS",
    "PVC-U", "PP", "PE100", "PPR", "Alluminio",
  ],
  P11_tenuta: ["PTFE", "EPDM", "NBR", "FKM/Viton", "Grafite", "Metallo-metallo"],
  P13_tipo_otturatore: [
    "Sfera", "Farfalla", "Saracinesca cuneo",
    "Globo otturatore", "Membrana",
  ],
  P16_azionamento: [
    "Manuale leva", "Manuale volantino",
    "Attuatore pneumatico SR", "Attuatore pneumatico DA",
    "Attuatore elettrico 24V", "Attuatore elettrico 230V",
  ],
  P18_fluido: [
    "Acqua fredda sanitaria", "Acqua calda riscaldamento",
    "Vapore saturo", "Vapore surriscaldato",
    "Olio diatermico", "Aria compressa",
    "Gas combustibile", "Acqua antincendio",
    "Fluido alimentare", "Fluido farmaceutico",
    "Fluido chimico aggressivo", "Acqua potabile",
  ],
  P21_settore: [
    "Civile residenziale", "Industriale termotecnico",
    "Alimentare/Beverage", "Antincendio sprinkler",
  ],
  P22_certificazioni: [
    "EN 10204 2.2", "EN 10204 3.1", "EN 10204 3.2",
    "PED I", "PED II", "PED III", "PED IV",
    "MOCA Reg. 1935/2004", "UNI EN 12845",
    "DM 174/2004", "ATEX zone 1", "ATEX zone 2",
  ],
  P30_spessore: null,
  P31_schedule: ["SCH 5", "SCH 10", "SCH 20", "SCH 40", "SCH 80", "SCH 160"],
  P32_lunghezza_mm: null,
  P33_forma_fondello: [
    "Bombato", "Concavo", "Piatto",
    "Curva 45°", "Curva 90°", "Curva 180°",
    "Tee equal", "Tee riducente", "Croce",
  ],
  P34_tipo_flangia: [
    "Slip-on", "Welding-neck", "Cieca",
    "Lap-joint", "Threaded", "Socket-weld",
  ],
  P35_finitura_facing: ["RF", "FF", "RTJ", "LM"],
  P36_tipo_valvola_reg: [
    "Riduttrice pressione", "Valvola sicurezza", "Valvola ritegno",
    "Regolazione modulante", "Scarico termico", "By-pass",
  ],
  P37_kv_rated: null,
  P38_range_taratura: null, // free text
  P39_dim_lxl: null,
  P40_finitura_superficie: [
    "Decapata", "Zincata",
    "Inox 2B", "Inox 4N satinata", "Inox BA",
    "Verniciata", "Grezza",
  ],
  P41_tipo_strumento: [
    "Manometro", "Termometro", "Pressostato", "Flussostato",
    "Livellostato", "Misuratore portata", "Trasmettitore pressione",
  ],
  P42_attacco_strumento: ["Radiale", "Posteriore", "Inferiore"],
  P43_portata_m3h: null,
  P44_prevalenza_m: null,
  P45_potenza_kw: null,
  P46_alimentazione: [
    "Monofase 230V", "Trifase 400V", "Trifase 690V", "DC 24V",
  ],
  P47_tipo_scambiatore: ["A piastre", "Fascio tubiero", "A doppio tubo", "A spirale"],
  P48_tipo_accessorio: [
    "Filtro a Y", "Filtro defangatore", "Valvola a sfera",
    "Miscelatore 3 vie", "Miscelatore 4 vie", "Disaeratore",
    "Giunto antivibrante",
  ],
};

export const FAMIGLIE = {
  F01: "Tubi",
  F02: "Raccordi a saldare",
  F03: "Raccordi filettati/compressione/pressare",
  F04: "Flange e accessori",
  F05: "Valvole di intercettazione manuali",
  F06: "Valvole regolazione/sicurezza",
  F07: "Lamiere e profili",
  F08: "Strumentazione",
  F09: "Tubi flessibili / Compensatori",
  F10: "Pompe",
  F11: "Scambiatori di calore",
  F12: "Accessori termoidraulici",
};

export const SETTORI = {
  S01_civile_residenziale: "Civile residenziale",
  S03_industriale_termotecnico: "Industriale termotecnico",
  S05_alimentare: "Alimentare/Beverage",
  S07_navale: "Navale / Cantieri",
  S15_antincendio: "Antincendio Sprinkler",
};

// Mirror of backend T1 — obligatory (OBB) or optional (OPT) per family.
export const T1_OBB = {
  F01: [
    "P01_DN", "P30_spessore", "P02_connessione", "P06_PN", "P08_TS",
    "P10_materiale", "P18_fluido",
  ],
  F02: [
    "P01_DN", "P30_spessore", "P02_connessione", "P06_PN", "P10_materiale",
  ],
  F03: [
    "P01_DN", "P02_connessione", "P06_PN", "P10_materiale", "P18_fluido",
  ],
  F04: [
    "P01_DN", "P04_flangia_norma", "P06_PN", "P10_materiale",
    "P11_tenuta", "P18_fluido", "P34_tipo_flangia",
  ],
  F05: [
    "P01_DN", "P02_connessione", "P06_PN", "P08_TS",
    "P10_materiale", "P11_tenuta", "P13_tipo_otturatore",
    "P16_azionamento", "P18_fluido",
  ],
  F06: [
    "P01_DN", "P02_connessione", "P06_PN", "P10_materiale",
    "P18_fluido", "P36_tipo_valvola_reg",
  ],
  F07: ["P10_materiale", "P30_spessore", "P39_dim_lxl"],
  F08: ["P41_tipo_strumento", "P38_range_taratura", "P42_attacco_strumento"],
  F09: ["P01_DN", "P02_connessione", "P10_materiale", "P32_lunghezza_mm"],
  F10: [
    "P01_DN", "P10_materiale", "P43_portata_m3h",
    "P44_prevalenza_m", "P45_potenza_kw", "P46_alimentazione",
  ],
  F11: ["P47_tipo_scambiatore", "P10_materiale", "P45_potenza_kw"],
  F12: [
    "P48_tipo_accessorio", "P01_DN", "P02_connessione",
    "P06_PN", "P10_materiale",
  ],
};

// Optional (OPT) per family — rendered without red "Compila" when empty.
export const T1_OPT = {
  F01: ["P31_schedule", "P32_lunghezza_mm"],
  F02: ["P33_forma_fondello"],
  F03: ["P03_filettatura"],
  F04: ["P35_finitura_facing"],
  F06: ["P37_kv_rated", "P38_range_taratura"],
  F07: ["P40_finitura_superficie"],
  F09: ["P06_PN"],
  F10: ["P06_PN"],
  F11: ["P43_portata_m3h", "P01_DN"],
};

// Per-family hidden (NA) params: rendered as disabled "—" cell.
const NA_VALVOLE = [
  "P30_spessore", "P31_schedule", "P32_lunghezza_mm",
  "P33_forma_fondello", "P34_tipo_flangia", "P35_finitura_facing",
  "P39_dim_lxl", "P40_finitura_superficie",
  "P41_tipo_strumento", "P42_attacco_strumento",
  "P43_portata_m3h", "P44_prevalenza_m", "P45_potenza_kw",
  "P46_alimentazione", "P47_tipo_scambiatore", "P48_tipo_accessorio",
];

const NA_RACCORDI = [
  "P11_tenuta", "P13_tipo_otturatore", "P16_azionamento",
  "P33_forma_fondello", "P34_tipo_flangia", "P35_finitura_facing",
  "P36_tipo_valvola_reg", "P37_kv_rated", "P38_range_taratura",
  "P39_dim_lxl", "P40_finitura_superficie",
  "P41_tipo_strumento", "P42_attacco_strumento",
  "P43_portata_m3h", "P44_prevalenza_m", "P45_potenza_kw",
  "P46_alimentazione", "P47_tipo_scambiatore", "P48_tipo_accessorio",
];

export const T1_NA = {
  F01: NA_VALVOLE.filter((p) => p !== "P30_spessore" && p !== "P31_schedule" && p !== "P32_lunghezza_mm").concat([
    "P11_tenuta", "P13_tipo_otturatore", "P16_azionamento",
    "P34_tipo_flangia", "P35_finitura_facing", "P36_tipo_valvola_reg",
  ]),
  F02: NA_RACCORDI.filter((p) => p !== "P33_forma_fondello").concat(["P18_fluido"]),
  F03: NA_RACCORDI.filter((p) => p !== "P03_filettatura").concat(["P30_spessore"]),
  F04: NA_RACCORDI.filter((p) => p !== "P34_tipo_flangia" && p !== "P35_finitura_facing").concat(["P30_spessore"]),
  F05: NA_VALVOLE,
  F06: NA_VALVOLE.filter((p) => p !== "P36_tipo_valvola_reg" && p !== "P37_kv_rated" && p !== "P38_range_taratura").concat([
    "P11_tenuta", "P13_tipo_otturatore", "P16_azionamento",
  ]),
  F07: [
    "P01_DN", "P02_connessione", "P06_PN", "P08_TS",
    "P11_tenuta", "P13_tipo_otturatore", "P16_azionamento",
    "P18_fluido", "P31_schedule", "P32_lunghezza_mm",
    "P33_forma_fondello", "P34_tipo_flangia", "P35_finitura_facing",
    "P36_tipo_valvola_reg", "P37_kv_rated",
    "P41_tipo_strumento", "P42_attacco_strumento",
    "P43_portata_m3h", "P44_prevalenza_m", "P45_potenza_kw",
    "P46_alimentazione", "P47_tipo_scambiatore", "P48_tipo_accessorio",
  ],
  F08: [
    "P01_DN", "P02_connessione", "P06_PN", "P08_TS",
    "P11_tenuta", "P13_tipo_otturatore", "P16_azionamento",
    "P18_fluido", "P30_spessore", "P31_schedule",
    "P32_lunghezza_mm", "P33_forma_fondello", "P34_tipo_flangia",
    "P35_finitura_facing", "P36_tipo_valvola_reg", "P37_kv_rated",
    "P39_dim_lxl", "P40_finitura_superficie",
    "P43_portata_m3h", "P44_prevalenza_m", "P45_potenza_kw",
    "P46_alimentazione", "P47_tipo_scambiatore", "P48_tipo_accessorio",
  ],
  F09: NA_RACCORDI.concat(["P03_filettatura"]),
  F10: NA_VALVOLE.filter((p) => !["P43_portata_m3h", "P44_prevalenza_m", "P45_potenza_kw", "P46_alimentazione"].includes(p)).concat([
    "P11_tenuta", "P13_tipo_otturatore", "P16_azionamento",
  ]),
  F11: NA_VALVOLE.filter((p) => !["P47_tipo_scambiatore", "P45_potenza_kw", "P43_portata_m3h"].includes(p)).concat([
    "P11_tenuta", "P13_tipo_otturatore", "P16_azionamento",
  ]),
  F12: NA_VALVOLE.filter((p) => p !== "P48_tipo_accessorio"),
};

// Canonical display order across all 12 families.
const COLUMN_ORDER = [
  "P01_DN", "P30_spessore", "P31_schedule", "P32_lunghezza_mm",
  "P06_PN", "P10_materiale", "P11_tenuta",
  "P02_connessione", "P03_filettatura",
  "P34_tipo_flangia", "P35_finitura_facing", "P33_forma_fondello",
  "P13_tipo_otturatore", "P16_azionamento", "P18_fluido",
  "P36_tipo_valvola_reg", "P37_kv_rated", "P38_range_taratura",
  "P41_tipo_strumento", "P42_attacco_strumento",
  "P47_tipo_scambiatore", "P43_portata_m3h", "P44_prevalenza_m",
  "P45_potenza_kw", "P46_alimentazione",
  "P39_dim_lxl", "P40_finitura_superficie",
  "P48_tipo_accessorio", "P08_TS", "P22_certificazioni",
];

export function obligatoryParamsFor(famiglia) {
  return T1_OBB[famiglia] || T1_OBB.F05;
}

export function optionalParamsFor(famiglia) {
  return T1_OPT[famiglia] || [];
}

export function orderedParamColumns(famiglia) {
  const obb = new Set(obligatoryParamsFor(famiglia));
  const opt = new Set(optionalParamsFor(famiglia));
  // Show OBB and OPT columns; NA ones stay out of the visible set.
  return COLUMN_ORDER.filter((p) => obb.has(p) || opt.has(p));
}
